module.exports = __webpack_public_path__ + "static/media/successful.5ecf2519.svg";